<template>
    <div>
        <video-player
            :video-token="video.token"
            :resume-position="resumePosition"
            v-on:update-video-status="updateVideoStatus"
        ></video-player>
    </div>
</template>

<script>
import VideoPlayer from "@/Components/VideoPlayer";

export default {
    name: "StudentVideo",
    components: {
        VideoPlayer,
    },
    props: {
        video: {
            type: Object,
            default: {},
        },
        demoMode: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        updateVideoStatus: function (videoStatus) {
            if (this.demoMode) {
                return false;
            }

            let vm = this;
            axios.post("/student/videos/update-video-history", {
                video_id: vm.video.id,
                ...videoStatus,
            });
        },
    },
    computed: {
        resumePosition() {
            let resume_position = 0;

            if (this.video.user_watch_history) {
                resume_position = this.video.user_watch_history.resume_position;
            }

            return resume_position;
        },
    },
};
</script>

<style scoped></style>
